import { RxStompService } from "./rxstomp.service";
import { myRxStompConfig } from "./RxStompConfig";


export function rxStompServiceFactory() {
  const rxStomp = new RxStompService();
  rxStomp.configure(myRxStompConfig);
 // rxStomp.activate();
  return rxStomp;
}
